module.exports = __webpack_public_path__ + "static/media/posimg.2e4b6b61.png";